"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_datepicker_1 = require("react-datepicker");
require("react-datepicker/dist/react-datepicker.css");
var moment = require("moment");
var layout_1 = require("../layout");
require("./CalendarBar.scss");
var constants_1 = require("../../../../constants");
var CalendarBar = function (props) {
    var date = props.date, onDateChange = props.onDateChange, name = props.name, locale = props.locale, max = props.max, min = props.min;
    return (React.createElement("div", { className: "calendar-bar" },
        React.createElement(layout_1.Row, { justifyContent: "space-around", alignItems: "center" },
            React.createElement("i", { className: "material-icons" }, "date_range"),
            React.createElement(react_datepicker_1.default, { selected: moment(date).toDate(), onChange: function (changingDate) { return onDateChange(moment(changingDate).format(constants_1.DATE_FORMAT)); }, dateFormat: "EE dd-MM-YYYY", maxDate: max ? max.toDate() : null, minDate: min ? min.toDate() : null, name: name, locale: locale }))));
};
exports.default = CalendarBar;
